/**
 * EN – Main entry: merges all project translations into one object
 * Used as default "translation" namespace in i18n
 */

import core from "./core/index.js";
import tax from "./tax/index.js";
import epr from "./epr/index.js";
import invoice from "./invoice/index.js";
import authorize from "./authorize/index.js";
import marketplace from "./marketplace/index.js";

const en = {
  ...core,
  ...tax,
  ...epr,
  ...invoice,
  ...authorize,
  ...marketplace,
};

export default en;
